var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aboutGoods"},[(_vm.facility=='app')?_c('div',{staticClass:"content"},[_c('App')],1):_c('div',[_c('Pc')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }